import { useOktaAuth } from '@okta/okta-react';
import React from 'react';
import { Link } from 'react-router-dom';
import { Box, Flex, Text } from '@chakra-ui/react';

const Navbar = () => {
  const { authState, oktaAuth } = useOktaAuth();

  const login = async () => oktaAuth.signInWithRedirect();

  const logout = async () => {
    const basename = window.location.origin + '/';
    await oktaAuth.signOut({ postLogoutRedirectUri: basename });
  };

  if (!authState) {
    return null;
  }

  return (
    <Box
      as="nav"
      position="fixed"
      top={0}
      left={0}
      right={0}
      width="100%"
      bg="black"
      color="white"
      zIndex={1000}
      py={3}
      px={4}
    >
      <Flex
        alignItems="center"
        justifyContent="flex-start"
      >
        <Box className="ncss-brand">
          <Text
            fontSize="2xl"
            color="white"
            textTransform="uppercase"
            fontWeight="normal"
            display="flex"
            alignItems="center"
            gap={2}
          >
            <i className="g72-swoosh" style={{ fontSize: '1.5em' }}></i>
            <span 
              style={{ marginLeft: '8px', fontFamily: 'Nike Futura', fontWeight: 'bold', fontSize: '64px', lineHeight: '1' }}>
                ID Verify
            </span>
          </Text>
        </Box>
      </Flex>
    </Box>
  );
};
export default Navbar;
